module.exports = __webpack_public_path__ + "img/JingLiu.fa30ba98.png";